import React from 'react';
import { IconPackage, IconClipboardList } from '@tabler/icons-react';
import { getNoun } from '@utils/lib/getNoun';
import { OfferCard } from './offer-card';
import s from './interactive-message.module.scss';

// Карточка предложения пакета в чате.
// Информация одинаковая для преподавателя и ученика: детали берём из
// payload (его создатель отправил, бэк раздаёт обоим). Отличаются только
// кнопки — их бэк присылает только получателю. Если payload неполный —
// фолбэк на серверные card.title/card.lines (тоже одинаковые для обеих ролей).
export const PackageOfferEntityCard = ({ message }) => {
  const payload = message.payload || {};
  const card = message.card || {};

  const title = payload.title || payload.name || card.title || 'Предложение пакета';
  const lessonsCount = payload.lessons_count || payload.count;
  const price = payload.price;

  const hasDetails = lessonsCount || price;

  return (
    <OfferCard
      icon={<IconPackage size={20} />}
      title={title}
      status={card.status}
      actions={card.actions || []}
      message={message}
    >
      {hasDetails ? (
        <div className={s.chips}>
          {lessonsCount > 0 && (
            <span className={s.chip}>
              <IconClipboardList size={14} />
              {lessonsCount} {getNoun(lessonsCount, 'занятие', 'занятия', 'занятий')}
            </span>
          )}
          {price > 0 && (
            <span className={s.chip}>
              {Number(price).toLocaleString('ru-RU')} ₽
            </span>
          )}
        </div>
      ) : (
        Array.isArray(card.lines) &&
        card.lines.length > 0 && (
          <div className={s.lines}>
            {card.lines.map((line, index) => (
              <span key={index} className={s.line}>
                {line}
              </span>
            ))}
          </div>
        )
      )}
    </OfferCard>
  );
};
